// extracted by mini-css-extract-plugin
export var footer = "_lv-0";
export var inherit = "_lv-1";
export var input = "_lv-2";
export var modalContent = "_lv-3";
export var quillEditor = "_lv-4";
export var subtitle = "_lv-5";